import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Participant from '../../entities/participant';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteParticipant(): boolean {
return true;
}
export function collectParticipantDeleteImpact(participant: Participant, context: DeleteImpactContext): void {
const key = 'participant:' + participant.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
}
export function deleteImpactParticipant(participant: Participant): DeleteImpact {
const context = deleteImpactContext();
collectParticipantDeleteImpact(participant, context);
return deleteImpactCounts(context);
}
export function deleteParticipant(participant: Participant, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteParticipant()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectParticipantDeleteImpact(participant, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || participant.id};
}
const key = 'participant:' + participant.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));

const deleted = participant.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.ParticipantActions.removeParticipantQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}
